var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 28,
    viewBox: "0 0 183 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_18123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5459 25.5527L0 13.9995L11.5459 2.44629L23.0918 13.9995L11.5459 25.5527ZM4.07881 13.9995L11.5459 21.4713L19.013 13.9995L11.5459 6.52769L4.07881 13.9995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5454 18.8597L6.68848 13.9997L11.5454 9.13965L16.4024 13.9997L11.5454 18.8597ZM10.7673 13.9997L11.5454 14.7783L12.3236 13.9997L11.5454 13.221L10.7673 13.9997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.303 1.6084H121.14V26.3881H125.303V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.659 1.6084H132.495V26.3881H136.659V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.321 11.2203L122.55 15.2393L123.894 19.1825L135.665 15.1636L134.321 11.2203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.766 27.0404L139.691 14.3502L148.679 0.956055L158.127 13.7443L148.766 27.0404ZM144.528 14.247L148.748 20.3343L153.237 13.7443L148.836 8.18552L144.528 14.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.721 27.3761L104.157 24.0889L110.047 19.4892L102.645 10.4575L112.261 0.624023L115.237 3.53747L108.233 10.7025L115.973 20.1493L106.721 27.3761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.396 26.1361L163.345 26.0587L158.27 2.75118L162.338 1.86426L165.554 16.6248L168.906 3.65873L172.961 3.76702L175.42 15.9107L178.97 2.26905L183 3.3184L177.182 25.6771L173.126 25.5663L170.673 13.4562L167.396 26.1361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2459 1.6084H58.082V26.3881H62.2459V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6013 1.6084H69.4375V26.3881H73.6013V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2642 11.2203L59.4932 15.2393L60.8378 19.1825L72.6088 15.1636L71.2642 11.2203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3461 1.63965H38.7031V5.80613H53.3461V1.63965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1052 3.72266H43.9414V26.3573H48.1052V3.72266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4944 28L76.4922 13.1466L85.6573 0L89.0739 2.3849L81.6223 13.0744L90.8389 25.5171L87.4944 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1664 11.0273H79.0557V15.1938H89.1664V11.0273Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_18123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramShow);
export default __webpack_public_path__ + "static/media/programShow.09dd86538f623aa4e4f14b5f128beeaa.svg";
export { ForwardRef as ReactComponent };